import { ReactNode } from "react";
import { LoadingBlock } from "../Loading/LoadingRows.tsx";

export function SummaryStat({
  label,
  value,
  loading = false,
  children,
}: {
  label: string;
  value: string;
  loading?: boolean;
  children?: ReactNode;
}) {
  return (
    <div className={"flex flex-col gap-0.5"}>
      <span className={"text-xs text-slate-500"}>{label}</span>
      {loading ? (
        <LoadingBlock sizeClassName={"h-7 w-20 my-0.5"} />
      ) : (
        <span className={"text-xl font-bold text-slate-800"}>{value}</span>
      )}
      {!loading && children}
    </div>
  );
}
